import { render, staticRenderFns } from "./LocationSearch.vue?vue&type=template&id=2870e3d1"
import script from "./LocationSearch.vue?vue&type=script&lang=js"
export * from "./LocationSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports